// A postal address from the company's billing details (backend billing_routes.BillingDetailsBody), as invoices and the
// brand on documents show it: "Torstraße 12, 10119 Berlin, Germany", the country named by the browser in English.
const REGION = new Intl.DisplayNames(["en"], { type: "region" });

export const countryName = (code) => { try { return REGION.of(code) || code; } catch { return code; } };

export const addressLine = (d) => [d.address, [d.zip_code, d.city].filter(Boolean).join(" "), d.state, countryName(d.country)]
  .filter(Boolean).join(", ");
